export class PlateRating {
  constructor(
    public registration: string,
    public rating: boolean,
    public term: string
  ) {}
}
